import { BAR_SPOTS } from './BarRoom';
import type { Vec2 } from './layout';
import { BAR_SLOT, roomCenter } from './rooms';

/** A spot inside the Rusty Spur in world coordinates (for NPC homes). */
export function barSpot(name: keyof typeof BAR_SPOTS): Vec2 {
  const c = roomCenter(BAR_SLOT);
  const p = BAR_SPOTS[name];
  return { x: c.x + p.x, z: c.z + p.z };
}
